(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sms-dealer-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sms-dealer-savings')) {
  class SMSDealerSavings extends HTMLElement {
    static retailRequests = new Map();
    connectedCallback() {
      this.prices = JSON.parse(this.querySelector('[data-dealer-prices]').textContent);
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.controller = new AbortController();
      this.lastKey = '';
      this.sync = this.sync.bind(this);
      this.onVariant = event => {
        const detail = event.detail || {};
        const variant = detail.variant;
        if (variant && Object.prototype.hasOwnProperty.call(this.prices, String(variant.id)) && Number.isFinite(variant.price)) {
          this.prices[String(variant.id)] = variant.price;
        }
        queueMicrotask(this.sync);
      };
      for (const name of ['change', 'input', 'variant:change', 'variant:changed']) {
        this.form.addEventListener(name, this.onVariant, { signal: this.controller.signal });
      }
      document.addEventListener('sms:variant:change', event => {
        if (event.detail?.form === this.form || this.form.contains(event.target)) this.onVariant(event);
      }, { signal: this.controller.signal });
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.lastKey = '';
    }
    async sync() {
      const field = this.form.querySelector('[name="id"]');
      const id = String(field?.value || this.dataset.variantId);
      const dealer = this.prices[id];
      const key = id + ':' + dealer;
      if (key === this.lastKey) return;
      this.lastKey = key;
      this.hidden = true;
      if (!Number.isFinite(dealer) || dealer < 0) return;
      const country = this.dataset.country;
      const cacheKey = country + ':' + id;
      try {
        if (!SMSDealerSavings.retailRequests.has(cacheKey)) {
          const request = fetch('/api/2026-07/graphql.json', {
            method: 'POST',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            signal: AbortSignal.timeout(8000),
            body: JSON.stringify({
              query: 'query DealerRetailReference($id:ID!,$country:CountryCode!) @inContext(country:$country){node(id:$id){... on ProductVariant{id price{amount currencyCode}}}}',
              variables: { id: 'gid://shopify/ProductVariant/' + id, country }
            })
          }).then(response => {
            if (!response.ok) throw new Error('Retail price unavailable');
            return response.json();
          }).then(result => {
            if (result.errors || !result.data?.node?.price) throw new Error('Retail price unavailable');
            return result.data.node.price;
          }).catch(error => {
            SMSDealerSavings.retailRequests.delete(cacheKey);
            throw error;
          });
          SMSDealerSavings.retailRequests.set(cacheKey, request);
        }
        const price = await SMSDealerSavings.retailRequests.get(cacheKey);
        if (!this.isConnected || this.lastKey !== key || price.currencyCode !== this.dataset.currency) return;
        const retail = Math.round(Number(price.amount) * 100);
        if (!Number.isFinite(retail) || retail <= dealer) return;
        const saving = retail - dealer;
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: price.currencyCode });
        const percent = Math.round(saving / retail * 100);
        this.querySelector('[data-retail-label]').textContent = this.dataset.retailLabel;
        this.querySelector('[data-retail-price]').textContent = money.format(retail / 100);
        this.querySelector('[data-saving]').textContent = this.dataset.saveLabel + ' ' + money.format(saving / 100) + ' · ' + percent + '% ' + this.dataset.percentLabel;
        this.hidden = false;
      } catch {
        if (this.lastKey === key) this.hidden = true;
      }
    }
  }
  customElements.define('sms-dealer-savings', SMSDealerSavings);
}
  } catch(e) { console.error(e); }
})();

})();
